import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet } from "../../../DataService/apiClient";
import { UserCourseListItem } from "../../../Types/UserCourseTypes";
import "../MemberDashboard.css";

export const DashboardCourses = () => {

  const navigate = useNavigate();

  const [courses, setCourses] = useState<UserCourseListItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCourses();
  }, []);

  const loadCourses = async () => {

    try {

      const res = await apiGet<UserCourseListItem[]>("/UserCourse/my-courses");

      setCourses(res ?? []);

    } catch (err) {
      console.error("Courses load error", err);
    }

    setLoading(false);

  };

  const openCourse = (courseId: number) => {
    navigate(`/member/courses/${courseId}`);
  };

  if (loading) {
    return (
      <div className="dashboard-section">
        <p>Laddar kurser...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-section">

      <div className="dashboard-header">
        <h1>Mina kurser</h1>
        <p>Öppna en kurs och fortsätt där du slutade.</p>
      </div>

      {courses.length === 0 && (
        <div className="dashboard-empty">
          <p>Du har inga kurser ännu. När du köper en kurs visas den här.</p>
        </div>
      )}

      <div className="dashboard-grid">

        {courses.map((course) => {

          const progress =
            course.totalChapters > 0
              ? (course.completedChapters / course.totalChapters) * 100
              : 0;

          return (
            <div
              key={course.courseId}
              className="dashboard-course-card"
              onClick={() => openCourse(course.courseId)}
            >

              {course.thumbnail ? (
                <img src={course.thumbnail} alt={course.title} />
              ) : (
                <div className="dashboard-course-fallback">{course.title}</div>
              )}

              <div className="dashboard-course-info">

                <span className="dashboard-category">
                  {course.category}
                </span>

                <h3>{course.title}</h3>

                <p className="dashboard-course-access">{course.accessType}</p>

                <div className="dashboard-progress">

                  <div
                    className="dashboard-progress-bar"
                    style={{
                      width: `${progress}%`
                    }}
                  />

                </div>

                <div className="dashboard-progress-text">
                  {course.completedChapters} / {course.totalChapters} kapitel
                </div>

                <button type="button" className="dashboard-course-inline-cta" onClick={() => openCourse(course.courseId)}>
                  Fortsätt kurs
                </button>

                {course.accessExpiresAt && (
                  <div className="dashboard-course-expiry">
                    Giltigt till {new Date(course.accessExpiresAt).toLocaleDateString()}
                  </div>
                )}

              </div>

            </div>
          );
        })}

      </div>

    </div>
  );
};
